"use client";

import { motion } from "motion/react";
import Image from "next/image";
import Link from "next/link";

export default function Home() {
  return (
    <main className="flex-1 flex items-center justify-center min-h-[calc(100vh-140px)] font-sans px-4 sm:px-6 lg:px-8">
      <motion.div
        className="border rounded-3xl shadow-sm shadow-purple-100 p-6 sm:p-8 md:p-10 lg:p-12 xl:p-16 text-center w-full max-w-sm sm:max-w-md md:max-w-lg backdrop-blur-3xl mx-auto"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h1 className="text-3xl md:text-5xl drop-shadow">
          <span className="font-extrabold text-[#069EDB] bg-clip-text bg-gradient-to-r">
            Welcome to
          </span>
        </h1>

        <div className="flex items-center justify-center gap-4 sm:gap-6 ">
          <div className="relative w-32 h-16 sm:w-40 sm:h-20 md:w-52 md:h-24 lg:w-60 lg:h-28">
            <Image
              src={"/foundation32-logo.png"}
              alt="Foundation32 Logo"
              fill
              className="object-contain"
              priority
              unoptimized
            />
          </div>
        </div>

        <p className="text-white text-md sm:text-lg lg:text-xl font-semibold mb-6 leading-relaxed">
          Start your journey with us and enjoy{" "}
          <span className="font-bold text-white">exclusive benefits</span>.
        </p>

        <Link
          href="/welcome-offer"
          className="inline-block bg-[#069EDB] text-white px-5 py-2 sm:px-6 sm:py-2.5 rounded-lg shadow-lg hover:scale-105 hover:shadow-xl transition-transform duration-200 font-bold text-sm sm:text-base w-full sm:w-auto"
        >
          View Offer
        </Link>
      </motion.div>
    </main>
  );
}
